const blobUrlByKey = new Map();
const inflightByKey = new Map();
const refCountByKey = new Map();

export const acquireBlobUrl = async (key, factory) => {
    if (!key) {
        return null;
    }

    refCountByKey.set(key, (refCountByKey.get(key) || 0) + 1);

    if (blobUrlByKey.has(key)) {
        return blobUrlByKey.get(key);
    }

    if (inflightByKey.has(key)) {
        return inflightByKey.get(key);
    }

    const promise = factory()
        .then((blobUrl) => {
            if (blobUrl) {
                blobUrlByKey.set(key, blobUrl);
            }
            return blobUrl;
        })
        .finally(() => {
            inflightByKey.delete(key);
        });

    inflightByKey.set(key, promise);

    return promise;
};

export const releaseBlobUrl = (key) => {
    if (!key || !refCountByKey.has(key)) {
        return;
    }

    const nextCount = (refCountByKey.get(key) || 1) - 1;

    if (nextCount <= 0) {
        const blobUrl = blobUrlByKey.get(key);
        if (blobUrl) {
            URL.revokeObjectURL(blobUrl);
        }
        blobUrlByKey.delete(key);
        refCountByKey.delete(key);
        return;
    }

    refCountByKey.set(key, nextCount);
};
